export module ioArray {

    export function ioGroupBy(_array: any, _groupBy: { field: string, childfield?: string }, _existArray?: any[], _parentElement?: any) {
        const _result: any[] = _existArray || [];
        _array.forEach(function (_element) {
            if (_element instanceof Object) {
                for (const _field in _element) {
                    if (_groupBy.field === _field) {
                        if (_groupBy.childfield) {
                            ioGroupBy(_element[_field], { field: _groupBy.childfield }, _result, _element);
                        } else {
                            const _resultItem: {} = _element;
                            const _resultIndx = _result.indexOf((_r) => _r === _resultItem);
                            if (_resultIndx === -1) {
                                _result.push(_resultItem);
                            }
                        }
                    }
                }
            } else {
                console.warn('Not available ioGroupBy type');
            }
        });
        return _result;
    }

    //TODO : Add id and parentid fields as parameters 
    export function ioTreeViewBuilder(inputdata: any, id= 'id', parentid= 'parentid') {

        let TreeViewData = [];
        let TreeViewElement;  
        TreeViewBuilder(TreeViewData, '0');

        return TreeViewData

        // TREEVIEW FUNCTION TO CONVERT ARRAY WITH PARENT CHILD TO TREEVIEW STRUCTURE
        function TreeViewBuilder(_children_arr, _parent_id) {
            // find all TreeViewElement with parent "parent"

            for (let i = 0; i < inputdata.length; i++) {
                TreeViewElement = inputdata[i];

                // Check if Element is Shared or belong to that User
                // PROCESS ONLY NOT USERs LISTS

                //  if (_userID !== TreeViewElement.OwnerID) { // SHARED OR SYSTEM LISTs THAT A USER HAS ACCESS
                // TreeViewElement.ParentListID = "0" //SET TO ROOT
                // Check in our data array ( ALL LISTS ) if that ParentID Exist as Element with ListID=ParentID
                // In order to add it on our TreeView Otherwise that element will become Root
                const ParentElement = inputdata.find((p) => p[id] === TreeViewElement[parentid]);
                if (!ParentElement) { TreeViewElement[parentid] = '0'; } // PARENT OF THIS ELEMENT DOES NOT EXIST SO RESET TO-ROOT
                // }

                if (TreeViewElement[parentid] === _parent_id) {
                    _children_arr.push(TreeViewElement);
                    TreeViewElement.children = [];
                    TreeViewBuilder(TreeViewElement.children, TreeViewElement.id);
                }

            }

            // // SORT Childrens Data by Name ignore Folders
            // children_arr.sort((a, b) => {
            //   // if (a.isFolder) { return 0; } // Do not Sort Children Folders
            //   if (a.item < b.item) { return -1; }
            //   if (a.item > b.item) { return 1; }
            //   return 0;
            //   // return a.ListName.downcase == b.ListName.downcase;
            // });

        }




    }

}
